export default __webpack_public_path__ + "static/media/LinkedIn Logo.6b95ceb8.svg";